import { render } from "./SingleEventSite.vue?vue&type=template&id=c6838064&scoped=true"
import script from "./SingleEventSite.vue?vue&type=script&lang=js"
export * from "./SingleEventSite.vue?vue&type=script&lang=js"

import "./SingleEventSite.vue?vue&type=style&index=0&id=c6838064&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6838064"]])

export default __exports__